const langConstants = {
  CHANGE: 'CHANGE_LANG',
};

export default langConstants;
